export const CLIENT_ENDPOINT = '/auto-enrollment';